import { useState } from "react";

import { CriminalRecordTemplateDetails } from "./steps/CriminalRecordTemplateDetails";
import {
  CriminalRecordTemplatesContext,
  initialCriminalRecordTemplateValues,
} from "./CriminalRecordTemplatesContext";
import { CriminalRecordTemplateFormValues } from "../types";

export function CriminalRecordTemplatesPage() {
  const [criminalRecordTemplate, setCriminalRecordTemplate] =
    useState<CriminalRecordTemplateFormValues>(
      initialCriminalRecordTemplateValues
    );

  return (
    <CriminalRecordTemplatesContext.Provider
      value={{
        criminalRecordTemplate,
        setCriminalRecordTemplate,
      }}
    >
      <CriminalRecordTemplateDetails />
    </CriminalRecordTemplatesContext.Provider>
  );
}
